import { render, staticRenderFns } from "./VersionBadge.vue?vue&type=template&id=a8f5dc5e&scoped=true"
import script from "./VersionBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VersionBadge.vue?vue&type=style&index=0&id=a8f5dc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5dc5e",
  null
  
)

export default component.exports